import React, { useRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import { IconBrandFacebookFilled, IconBrandInstagram } from "@tabler/icons-react";
import { useAppConfig } from "@ct-react/core";
import { LocaleLink, useLocaleContext } from "@ct-react/locale";
import { SiteType } from "@shared/site-type";
import Wrapper from "./wrapper";
import { useSeason } from "../../hooks/generic";
import { RGPDBanner } from "../../code-splitting/rgpd";
import summerBg from "../../assets/backgrounds/footer-bg-summer.webp";
import winterBg from "../../assets/backgrounds/footer-bg-winter.webp";
import SiteLogo from "../common/logo";
import "./footer.scss";

const transDefs = defineMessages({
  copyright: { id: "copyright", defaultMessage: "tous droits réservés." },
  terms: { id: "legal-terms-link", defaultMessage: "dispositions contractuelles générales" },
  mentions: { id: "legal-mentions-link", defaultMessage: "mentions légales" },
  legal: { id: "legal-text", defaultMessage: "L'utilisation de ce site constitue l'acceptation des {terms} et des {mentions} de rentalp.com. Ce site est protégé par reCAPTCHA." }
});

const Footer = () => {

  const intl = useIntl();
  const { locale } = useLocaleContext();
  const { options: { asAgency, siteType } } = useAppConfig();
  const season = useSeason();
  const year = useRef<string>(`© ${new Date().getFullYear()}`);

  return (
    <Wrapper.Backgrounded as="footer"
                          className="rl-footer"
                          ratio={18}
                          imagePath={season === "winter" ? winterBg : summerBg}>
      {!asAgency &&
        <>
          <LocaleLink to="/"><SiteLogo /></LocaleLink>
          {siteType === SiteType.RENTALP &&
            <ul className="socials">
              <li>
                <a href="https://www.instagram.com/rentalp.com_/" target="_blank">
                  <IconBrandInstagram />
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/Rentalp.ch" target="_blank">
                  <IconBrandFacebookFilled />
                </a>
              </li>
            </ul>
          }
          {siteType === SiteType.HOMEALP &&
            <ul className="socials">

                <li>
                  <a href="https://www.instagram.com/homealp.com_/" target="_blank">
                    <IconBrandInstagram/>
                  </a>
                </li>
              <li>
                <a href="https://www.facebook.com/homealp.ch" target="_blank">
                  <IconBrandFacebookFilled/>
                </a>
              </li>
            </ul>
          }
        </>
      }
      <span className="terms">
        {intl.formatMessage(transDefs.legal, {
          terms: <a href={`/public/conditions/${siteType.toLowerCase()}-terms-${locale.basename}.pdf`} target="_blank">
            {intl.formatMessage(transDefs.terms)}
          </a>,
          mentions: <a href={`/public/conditions/${siteType.toLowerCase()}-mentions-${locale.basename}.pdf`} target="_blank">
            {intl.formatMessage(transDefs.mentions)}
          </a>
        })}
      </span>
      <RGPDBanner />
      <div className="copy">
        <span>{year.current}</span>
        <a href="https://www.creative-technologies.ch/" target="_blank">C.T. Creative Technologies SA</a>
        <span>{intl.formatMessage(transDefs.copyright)}</span>
      </div>

    </Wrapper.Backgrounded>);

};

export default Footer;
